import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// ─── FR (Français — default) ───
import frCommon from '../locales/fr/common.json';
import frAuth from '../locales/fr/auth.json';
import frDocuments from '../locales/fr/documents.json';
import frDashboard from '../locales/fr/dashboard.json';
import frStudio from '../locales/fr/studio.json';
import frSettings from '../locales/fr/settings.json';
import frLegal from '../locales/fr/legal.json';
import frCreator from '../locales/fr/creator.json';
import frAdmin from '../locales/fr/admin.json';
import frNegotiation from '../locales/fr/negotiation.json';
import frTemplates from '../locales/fr/templates.json';
import frCourtportal from '../locales/fr/courtportal.json';
import frLanding from '../locales/fr/landing.json';
import frContracts from '../locales/fr/contracts.json';
import frPrediction from '../locales/fr/prediction.json';
import frCalculators from '../locales/fr/calculators.json';
import frAnalytics from '../locales/fr/analytics.json';
import frTrash from '../locales/fr/trash.json';
import frPricing from '../locales/fr/pricing.json';
import frHistory from '../locales/fr/history.json';
import frAgent from '../locales/fr/agent.json';
import frUserinbox from '../locales/fr/userinbox.json';
import frAdmininbox from '../locales/fr/admininbox.json';
import frDuediligence from '../locales/fr/duediligence.json';
import frKnowledge from '../locales/fr/knowledge.json';
import frKnowledgegraph from '../locales/fr/knowledgegraph.json';
import frPdflab from '../locales/fr/pdflab.json';
import frCompliance from '../locales/fr/compliance.json';
import frBenchmark from '../locales/fr/benchmark.json';
import frDeveloper from '../locales/fr/developer.json';
import frSources from '../locales/fr/sources.json';
import frAdvice from '../locales/fr/advice.json';

// ─── EN (English) ───
import enCommon from '../locales/en/common.json';
import enAuth from '../locales/en/auth.json';
import enDocuments from '../locales/en/documents.json';
import enDashboard from '../locales/en/dashboard.json';
import enStudio from '../locales/en/studio.json';
import enSettings from '../locales/en/settings.json';
import enLegal from '../locales/en/legal.json';
import enCreator from '../locales/en/creator.json';
import enAdmin from '../locales/en/admin.json';
import enNegotiation from '../locales/en/negotiation.json';
import enTemplates from '../locales/en/templates.json';
import enCourtportal from '../locales/en/courtportal.json';
import enLanding from '../locales/en/landing.json';
import enContracts from '../locales/en/contracts.json';
import enPrediction from '../locales/en/prediction.json';
import enCalculators from '../locales/en/calculators.json';
import enAnalytics from '../locales/en/analytics.json';
import enTrash from '../locales/en/trash.json';
import enPricing from '../locales/en/pricing.json';
import enHistory from '../locales/en/history.json';
import enAgent from '../locales/en/agent.json';
import enUserinbox from '../locales/en/userinbox.json';
import enAdmininbox from '../locales/en/admininbox.json';
import enDuediligence from '../locales/en/duediligence.json';
import enKnowledge from '../locales/en/knowledge.json';
import enKnowledgegraph from '../locales/en/knowledgegraph.json';
import enPdflab from '../locales/en/pdflab.json';
import enCompliance from '../locales/en/compliance.json';
import enBenchmark from '../locales/en/benchmark.json';
import enDeveloper from '../locales/en/developer.json';
import enSources from '../locales/en/sources.json';
import enAdvice from '../locales/en/advice.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '\u{1F1EB}\u{1F1F7}' },
  { code: 'en', name: 'English', flag: '\u{1F1EC}\u{1F1E7}' },
];

const ALL_NS = [
  'common', 'auth', 'documents', 'dashboard', 'studio', 'settings',
  'legal', 'creator', 'admin', 'negotiation', 'templates', 'courtportal',
  'landing', 'contracts', 'prediction', 'calculators', 'analytics', 'trash', 'pricing',
  'history', 'agent', 'userinbox', 'admininbox', 'duediligence',
  'knowledge', 'knowledgegraph', 'pdflab', 'compliance', 'benchmark',
  'developer', 'sources', 'advice',
];

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        common: frCommon, auth: frAuth, documents: frDocuments, dashboard: frDashboard,
        studio: frStudio, settings: frSettings, legal: frLegal, creator: frCreator,
        admin: frAdmin, negotiation: frNegotiation, templates: frTemplates,
        courtportal: frCourtportal, landing: frLanding, contracts: frContracts,
        prediction: frPrediction, calculators: frCalculators, analytics: frAnalytics,
        trash: frTrash, pricing: frPricing, history: frHistory, agent: frAgent,
        userinbox: frUserinbox, admininbox: frAdmininbox, duediligence: frDuediligence,
        knowledge: frKnowledge, knowledgegraph: frKnowledgegraph, pdflab: frPdflab,
        compliance: frCompliance, benchmark: frBenchmark, developer: frDeveloper,
        sources: frSources,
        advice: frAdvice,
      },
      en: {
        common: enCommon, auth: enAuth, documents: enDocuments, dashboard: enDashboard,
        studio: enStudio, settings: enSettings, legal: enLegal, creator: enCreator,
        admin: enAdmin, negotiation: enNegotiation, templates: enTemplates,
        courtportal: enCourtportal, landing: enLanding, contracts: enContracts,
        prediction: enPrediction, calculators: enCalculators, analytics: enAnalytics,
        trash: enTrash, pricing: enPricing, history: enHistory, agent: enAgent,
        userinbox: enUserinbox, admininbox: enAdmininbox, duediligence: enDuediligence,
        knowledge: enKnowledge, knowledgegraph: enKnowledgegraph, pdflab: enPdflab,
        compliance: enCompliance, benchmark: enBenchmark, developer: enDeveloper,
        sources: enSources,
        advice: enAdvice,
      },
    },
    lng: localStorage.getItem('language') || 'fr',
    fallbackLng: 'fr',
    ns: ALL_NS,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
